/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/react-in-jsx-scope */
import { createContext, useContext, useState } from 'react'

export const NotificationContext = createContext()

const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState({})

  const getNotifications = (data) => {
    const notif = data
    setNotification(notif)
  }
  return (
    <NotificationContext.Provider value={{ notification, getNotifications, setNotification }}>
      {children}
    </NotificationContext.Provider>
  )
}

export default NotificationProvider

export const useNotification = () => useContext(NotificationContext)
